exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".hb-avatar{float:right;margin:15px 20px 5px 10px;color:#c7c7c7}.hb-avatar span{font-size:13px;font-weight:400;vertical-align:top}.hb-avatar img{height:32px;width:32px;border-radius:32px;border:solid 1px #fff;object-fit:contain;background:#000;margin:-6px 0 0 8px}", ""]);

// exports
